import { isAgentFamily } from '../store/graphFamily';
import { useState } from 'react';
import { useDiagnostics, DEV_TOOLS, scrub, type Category } from './diagnostics';
import { useSession } from '../store/sessionStore';
import { useChat } from '../store/chatStore';
import { useSurface } from '../a2ui/surfaceStore';

const TABS = { actions: 'Действия', data: 'Данные', state: 'Состояние', events: 'События' };
function Json({ data }: { data: unknown }) { return <pre>{JSON.stringify(scrub(data), null, 2)}</pre>; }
function StateView() {
  const session = useSession(); const chat = useChat(); const board = useSurface();
  return <Json data={{ threadId: session.threadId, assistantId: session.assistantId,
    chat: { status: chat.status, error: chat.error }, location: { coordinates: session.agentGeoSet ? session.agentGeo : session.geo, metadata: session.agentGeoMeta, permission: session.geoState },
    board: { rev: board.rev, components: board.components, issues: board.issues } }} />;
}
export default function DevTools() {
  const [tab, setTab] = useState<Category | 'state'>('actions');
  const enabled = useDiagnostics((s) => s.enabled);
  const entries = useDiagnostics((s) => s.entries);
  const threadId = useSession((s) => s.threadId);
  const assistantId = useSession((s) => s.assistantId);
  const [allThreads, setAllThreads] = useState(false);
  if (!DEV_TOOLS || !isAgentFamily(assistantId)) return null;
  const filtered = entries.filter((e) => (allThreads || e.ownerThreadId === threadId) && e.category === tab);
  return <section className="dev-diagnostics" aria-label="Диагностика">
        <h2>Отладка{enabled ? ' ●' : ''}</h2><p className="dev-muted">Запись только в этой вкладке, до 200 событий. Не добавляется в историю чата. Данные относятся только к графу «Агент».</p>
        <div className="dev-controls"><button className="btn" type="button" onClick={() => useDiagnostics.getState().setEnabled(!enabled)}>{enabled ? 'Приостановить запись' : 'Продолжить запись'}</button>
          <button className="btn btn--quiet" type="button" onClick={() => useDiagnostics.getState().clear()}>Очистить</button></div>
        <label className="dev-checkbox"><input type="checkbox" checked={allThreads} onChange={(e) => setAllThreads(e.target.checked)} />Все диалоги этой вкладки</label>
        <div className="dev-tabs" aria-label="Разделы диагностики">{Object.entries(TABS).map(([id, label]) =>
          <button className="btn btn--quiet" type="button" key={id} aria-pressed={tab === id} onClick={() => setTab(id as typeof tab)}>{label}</button>)}</div>
        {tab === 'state' ? <StateView /> : <>
          <p className="dev-muted">{filtered.length} событий · аргументы и результаты показаны в том объёме, который пришёл от сервера; большие данные сокращены.</p>
          {[...filtered].reverse().map((e) => <details key={e.id} className="dev-event"><summary>{new Date(e.at).toLocaleTimeString('ru')} · {e.stream === 'worker' ? 'Фоновая задача · ' : ''}{e.title}</summary>
            <small>Запуск: {e.runId ?? 'ещё не назначен'} · Тред: {e.threadId}</small><Json data={e.data} /></details>)}
        </>}
    </section>;
}
